// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kb-0";
export var fileList = "_kb-2";
export var removeFileButton = "_kb-1";